import _ from 'lodash'

const convertAdvancedOptionsToURLParams = function (filters) {
  const params = new URLSearchParams()
  for (const item of filters.advancedFilters) {
    params.append('property_name', item.property_name)
    params.append('operator', item.operator)
    params.append('value', item.value)
  }
  for (let key of Object.keys(filters)) {
    if (key === 'advancedFilters') {
      continue
    }
    filters[key] && params.append(key, filters[key])
  }
  return params
}

const convertUrlFiltersToURLParams = function (filters) {
  const params = new URLSearchParams()
  Object.keys(filters.filterParams)
    .filter(key => ['section', 'url_status', 'url'].includes(key))
    .forEach(key => {
      function addParams (value) {
        if (!value) {
          return
        }
        params.append('property_name', key)
        params.append('operator', 'equal')
        params.append('value', value)
      }
      if (filters.filterParams[key] instanceof Array) {
        filters.filterParams[key].forEach(item => {
          addParams(item)
        })
      } else {
        addParams(filters.filterParams[key])
      }
    })
  for (let key of Object.keys(filters)) {
    if (key === 'filterParams') {
      continue
    }
    filters[key] && params.append(key, filters[key])
  }
  return params
}

const findUrlBiId = function (list, urlId) {
  if (!list || !list.length) {
    return
  }
  while (_.get(list, '[0].type') !== 'url') {
    list = _.flatMap(list, (n) => n.children)
  }
  const result = list.filter((item) => item._id === urlId)
  return result.length && result[0]
}

/**
 * Helper that convert data to URL params and searching URL by id
 */
export {
  convertAdvancedOptionsToURLParams,
  convertUrlFiltersToURLParams,
  findUrlBiId
}
